import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  PLATFORM_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideNgIconLoader, withCaching } from '@ng-icons/core';
import { ERole, httpInterceptor, provideAuthConfig, sessionHandoffInitializerFactory } from '@helipagos/auth';
import { UserStoreService } from '@hp-core/services/user-store.service';
import { DatePipe } from '@angular/common';

import { provideLoadingBarRouter } from '@ngx-loading-bar/router';
import {
  CHECKOUT_BRAND,
  CHECKOUT_FRONT,
  provideApiBaseUrl,
  provideCommonUrl,
  provideComprobanteConfig,
} from '@hp-core/providers/provide-base-url';
import { provideBaseRouteNavigators } from '@hp-core/providers/provide-base-route-navigator';
import { providePostHog } from '@hp-core/analytics/posthog.config';
import { providePostHogErrorHandler } from '@hp-core/analytics/posthog-error-handler';

import { environment } from 'environment/environment';
import { baseRouteNavigatorsConstant } from './route-navigator/base-router-navigator';
import { appRoutes } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { provideAnimations } from '@angular/platform-browser/animations';
import Clarity from '@microsoft/clarity';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export class TranslateBrowserLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  public getTranslation(lang: string): Observable<unknown> {
    const timestamp = new Date().getTime();
    const url = `/i18n/${lang}.json?v=${timestamp}`;
    return this.http.get(url);
  }
}

TranslateHttpLoader;

export function translateBrowserLoaderFactory(httpClient: HttpClient): TranslateBrowserLoader {
  return new TranslateBrowserLoader(httpClient);
}

const projectId = 'rfl5w9wgaw';

Clarity.init(projectId);

const provideCheckoutBrandUrl = provideCommonUrl(CHECKOUT_BRAND);
const provideCheckoutFrontUrl = provideCommonUrl(CHECKOUT_FRONT);

// TODO: In a future, we can create a makeAppConfig to both apps
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([httpInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: sessionHandoffInitializerFactory,
      deps: [UserStoreService, PLATFORM_ID],
      multi: true,
    },
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
    DatePipe,
    provideApiBaseUrl(environment.apiBaseUrl),
    provideCheckoutBrandUrl(environment.middleendUrl),
    provideCheckoutFrontUrl(environment.frontendUrl),
    provideComprobanteConfig({
      apiUrl: environment.comprobanteApiUrl,
      pass: environment.comprobantePass,
      isProduction: environment.production,
    }),
    provideBaseRouteNavigators<ERole>(baseRouteNavigatorsConstant),
    provideLoadingBarRouter(),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: translateBrowserLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideAnimations(),
    provideAuthConfig({
      allowedRoles: [ERole.ROLE_ADMIN],
      urlRedirect: ['home'],
    }),
    providePostHog({ key: environment.posthogKey, host: environment.posthogHost }),
    providePostHogErrorHandler(),
  ],
};
